// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  min-height: 85px;
}

.row {
  font-size: 0.8rem;
}

.row-header {
  font-size: 0.7rem;
  font-style: italic;
  border-bottom-style: solid !important;
  border-bottom: thin;
  border-top-style: solid !important;
  border-top: thin;
}

.actionbutton {
  width: -webkit-fill-available;
}

.orario {
  width: 10%;
}

.titoletto-small,
ion-item p.titoletto-small {
  font-size: 0.8rem;
  white-space: normal;
  margin-top: 0%;
}

.sottotitoletto-small,
ion-item p.sottotitoletto-small {
  font-size: 0.7rem;
  margin-top: -4px;
}

.list,
ion-item p.list {
  font-size: 1rem;
  color: #222;
  margin: 0;
  padding: 0;
  margin-top: -5px;
}

.div-storico {
  margin-bottom: 10px;
  margin-left: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/recupero-viewer/recupero-viewer.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,gBAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AACA;EACI,iBAAA;EACA,kBAAA;EACA,qCAAA;EACA,mBAAA;EACA,kCAAA;EACA,gBAAA;AAEJ;;AACA;EACI,6BAAA;AAEJ;;AAEA;EACI,UAAA;AACJ;;AAEA;;EAEI,iBAAA;EACA,mBAAA;EACA,cAAA;AACJ;;AAEA;;EAEI,iBAAA;EACA,gBAAA;AACJ;;AAEA;;EAEI,eAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AACJ;;AAEA;EACI,mBAAA;EACA,iBAAA;AACJ","sourcesContent":[":host {\n    display:block;\n    min-height: 85px;\n}\n\n.row {\n    font-size: 0.8rem;\n}\n.row-header {\n    font-size: 0.7rem;\n    font-style: italic;\n    border-bottom-style: solid !important;\n    border-bottom: thin;\n    border-top-style: solid !important;\n    border-top: thin;\n}\n\n.actionbutton {\n    width: -webkit-fill-available;\n}\n\n\n.orario {\n    width: 10%;\n}\n  \n.titoletto-small,\n    ion-item p.titoletto-small {\n    font-size: 0.8rem;\n    white-space: normal;\n    margin-top: 0%;\n}\n\n.sottotitoletto-small,\n    ion-item p.sottotitoletto-small {\n    font-size: 0.7rem;\n    margin-top: -4px;\n}\n    \n.list,\n  ion-item p.list {\n    font-size: 1rem;\n    color: #222;\n    margin: 0;\n    padding: 0;\n    margin-top: -5px;\n}\n  \n.div-storico {\n    margin-bottom: 10px;\n    margin-left: 10px;\n}\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
